import { Store } from "@reduxjs/toolkit";
import axios, { AxiosError, AxiosResponse } from "axios";
import axiosRetry from "axios-retry";
import Buffer from 'buffer'
import * as msal from "@azure/msal-browser";
import { ApiCall, READY, UrlParams, WAITING, FAILED, KeyValuePair, COMPLETE, AVAILABLE } from "../redux/types";
import { createStringFromTemplate } from "../utils/string-utils";
import { getAPIHeaders, getAuthHeaders } from "../utils/auth-utils";


let msalApp:any = null
let config:any = {}
let keyTokens:string[] = []

const GRAPH_REQUESTS:any = {
  USER: {
    scopes: ['User.Read']
  },
  API: {
    // For Car Designer APIs
    scopes: ['api://893879db-45d8-434c-a566-3fafc3bb4f29/API'],
  }
}

const Api_Endpoints:KeyValuePair = {
  LOCAL: 'http://localhost:3030/api',
  QA1: 'https://qa-kcd3d.azurewebsites.net/api',
  QA2: 'https://qa-kcd3d-stage.azurewebsites.net/api',
}

const POLL_INTERVAL = 1000

const apiCalls: ApiCall[] = [
  // TODO: Add real Api endpoints here
  {
    type: "brochure",
    url: `/cad/{key}/brochures`,
    // url: `/cad/{configId}_{designId}/brochures`,
    // url: `${config.api_endpoint}/cad/{configId}_{designId}/brochures`,
    // url: "https://catfact.ninja/fact",
  },
  {
    type: "drawing",
    url: `/cad/{key}/cad-drawings`,
    // url: `${config.api_endpoint}/cad/{configId}_{designId}/cad-drawings`,
    // url: "https://api.ipify.org?format=json",
  },
]

async function setConfig() {

  try {

    const result = await axios.get('/env.json')

    if(result) {
      return {
        ...result.data,
      }
    }
  } catch (err:any) {
    if (process.env.NODE_ENV === "production") {
      throw Error("Error when loading the env.json file.")
    } else {
      const api_endpoint:string = Api_Endpoints.LOCAL
      // const api_endpoint = Api_Endpoints.QA1
      // const api_endpoint = Api_Endpoints.QA2

      return {
        clientID: '893879db-45d8-434c-a566-3fafc3bb4f29',
        cdUri: 'https://qa-cardesigner.kone.com',
        // dev: false,
        dev: true,
        api_endpoint,
        ui_auth_required: false,
      }
    }
  }  
}

async function setMsalApp() {
  const msalObj = new msal.PublicClientApplication({
    auth: {
      clientId: config.clientID,
      authority: 'https://login.microsoftonline.com/kone.onmicrosoft.com',
      // validateAuthority: true,
      redirectUri: `${window.location.protocol}//${window.location.host}`,
      // navigateToLoginRequestUrl: true,
      // postLogoutRedirectUri: '/',

    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true,
    }
  })

  msalObj.handleRedirectPromise().then(async (tokenResponse:any) => {
    let accountObj = null
    if (tokenResponse) {
      accountObj = tokenResponse.account
    } else {
      const currentAccounts = msalObj.getAllAccounts()
      if (!currentAccounts?.length) {
        return
      } else {
        // Can there be more than one? If so, which one to choose?
        accountObj = currentAccounts[0]
      }
    }
    
    if (accountObj) {
      msalObj.setActiveAccount(accountObj)

      const headers:any = await getAuthHeaders(msalObj, GRAPH_REQUESTS.USER)

      const graphEndpointAccount = 'https://graph.microsoft.com/v1.0/me'
      // photo not used as I have no clue what the valid response would be
      // (there is no photo setup for dev team accounts)
      // const graphEndpointPhoto = 'https://graph.microsoft.com/v1.0/me/photo/$value'

      const userResponse = await axios.get(graphEndpointAccount, { headers })
    }

  }).catch( (err:any) => {
    console.error('Failed getting account token response', err)
  })

  return msalObj
}

const pollingTypes:KeyValuePair = {}

function isDx( value:string) {
  if(
    value === 'ADE' ||
    value === 'KJL' ||
    value === 'LKE' ||
    value === 'GMR' ||
    value === 'TRZ'
  ) {
    return true
  }

  return false
}

function poll(apiProps: ApiCall, store: Store, params: KeyValuePair) {

  if (pollingTypes[apiProps.type]) {
    return  
  }
  pollingTypes[apiProps.type] = true
  // decorates url with params
  // eg. url/{product}/{language} --> url/PROD1/en:US
  const url = createStringFromTemplate(apiProps.url, params)

  let ready = true
  get(store, url).then(res => {
    // console.log('--->',res)
    for(var i = 0; i<res.length; i++) {
      if(res[i].state !== READY && res[i].state !== COMPLETE && res[i].state !== FAILED && res[i].state !== AVAILABLE) {
        ready = false
      }
    }

    store.dispatch({ type: "app/setRequestReachedTheBackend", payload: true})

    if (apiProps.type === "brochure") {

      store.dispatch({
        type: "app/updateBrochures", payload: [
          ...res,
        ]
//         type: "app/updateBrochures", payload: [
//           ...res,
//           // TODO: define predefined brochure here ...
// /*           {
//             name: 'cad-brochure-planning-guide',
//             type: 'brochure',
//             state: parsedResult.planningGuide === '' ? WAITING : READY,
//             url: parsedResult.planningGuide,
//             created: parsedResult.createdAt
//           },
//           {
//             name: "Brochure 4",
//             state: READY,
//             url: url,
//           } */
//         ]
      })
    }
    else if (apiProps.type === "drawing") {
      // TODO: Parse real results here
      const resWithUrl = res.map( (item:KeyValuePair) =>{
         return {
          ...item,
          url: config.api_endpoint+item.url
         }
      })
      store.dispatch({
        type: "app/updateDrawings", payload: [
          ...resWithUrl
/*           {
            name: "Drawing 1",
            state: ready ? READY : WAITING,
            url: ready ? url : undefined,
          },
          {
            name: "Drawing 2",
            state: ready ? READY : WAITING,
            url: ready ? url : undefined,
          } */
        ]
      })
    }

    if (!ready) {
      setTimeout(() => {
        pollingTypes[apiProps.type] = false
        poll(apiProps, store, params)
      }, POLL_INTERVAL)
    } else {
      pollingTypes[apiProps.type] = false
    }

  }).catch(error => {
    // TODO...
  })
}

async function get (store:Store ,path:string, options:KeyValuePair = {}, retryOptions:KeyValuePair = {retires:3, delay:2000}, byPassRetry:boolean = false ) {
  const { requireAuth, includeAuth, publicRoute } = options
  let headers:any = await getAPIHeaders({ msalApp, requireAuth, optionalAuth: includeAuth })

  headers['cd-domain'] = window.location.hostname

  const apiEndpoint:string = config.api_endpoint
  
  let result:any =null

  let client = axios.create({})

  // make an interceptor to catch the delay before the request has reached the backend
  client.interceptors.response.use((response: AxiosResponse) => {
    if (response.status === 204) {
      return Promise.reject({...response, status:425})
    }
    return response
  })

  if(!byPassRetry) {
    axiosRetry(client, {
      retries: retryOptions.retires,
      retryDelay: (retryCount) => {
        console.log('Retry GET, attempt:',retryCount)
        return retryCount * retryOptions.delay
      },
      retryCondition: (error) => {
        // console.log(error)
        if(error?.response?.status === 404) return false
        return true
      },
      
    })
  }

  try {
    result = await client.get(`${apiEndpoint}${path}`, {
    // result = await axios.get(path, {
      headers
    })
  } catch (err:any) {
    const msg:string = err.response?.headers?.['error-message'] || err.message
    console.error(`Error for GET ${path}: ${msg}`)
    return null
    // throw err
  }

  // Recaptcha replacement solution.
  // There should be three tokens sent to the server on post requests.
  if (result.headers['x-key-token']) {
    // Max three tokens. The tokens have to be in
    // order by time so the first one is removed when
    // a new one is received.
    if (keyTokens.length === 3) {
      keyTokens.shift()
    }

    // Get the token from the header and add it to the list.
    keyTokens.push(result.headers['x-key-token'])
    // store.dispatch({type:'app/setKeyTokensState', payload:[...keyTokens,result.headers['x-key-token']]})

    // clearTimeout(redirectTimer)
    
    // Redirect the user back to either the welcome page
    // or the editor if there has not been a new token
    // after a while. This is because the token times out,
    // so new one needs to be generated by going to the
    // contact page or the specification page again.
    // This should basically only happen if the user leaves
    // the Car Designer idle for an hour on these pages.

/*     redirectTimer = setTimeout(() => {
      if (history && history.location) {
        console.log('Token timeout! Redirecting')
        const { pathname } = history.location
        if (pathname === '/contact') {
          history.push(pathname.replace('contact', ''))
        } else if (pathname.includes('specification')) {
          history.push(pathname.replace('specification', 'edit'))
        }
      }
    }, 1000 * 60 * 60) // One hour */
  }

  return result.data
}

async function post(store: Store, path:string, data:KeyValuePair, options:any = {}) {
  const { requireAuth, withKeyToken, includeAuth } = options

  let headers:any = await getAPIHeaders({ requireAuth, optionalAuth: includeAuth }) 

  // const keyTokens = store.getState().app.keyTokens

  if (withKeyToken) {
    // Create a combined token from the list.
    // The separator has to be ':' or the token validation fails.
    headers['x-key-token'] = keyTokens.join(':')
  }

  headers['cd-domain'] = window.location.hostname

  try {
    const result = await axios.post(`${config.api_endpoint}${path}`, data, { 
      headers
    })
    
    return result.data
  } catch (err:any) {
    const msg = err.response?.headers?.['error-message'] || err.message
    console.error(`Error for POST ${path}: ${msg}`)
    return {status:'Error', err}
  }
}

export function startPolling(store: Store, params: KeyValuePair) {
  for (const apiProps of apiCalls) {
    poll(apiProps, store, params)
  }
}

export async function checkEmail( store: Store, downloadUrl:string) {
  const uniqueId = store.getState().app.configId+'_'+store.getState().app.designId
  const urlencode = window.btoa(downloadUrl)
  return await get(store, '/cad/'+uniqueId+'/is-email-set?downloadUrl='+urlencode,{},{retires:20, delay:2000})
}

export async function loadLinkInfo( store: Store) {
  const uniqueId = store.getState().app.rowKey
  // const uniqueId = store.getState().app.configId+'_'+store.getState().app.designId
  // return await get(store, '/cad/'+uniqueId+'/edit-info')
  return get(store, '/cad/'+uniqueId+'/edit-info')
}

export async function loadFrontlineCDProducts( store: Store, countryName:string) {
  // return await get(store, '/public/frontline/'+countryName+'/available')
  return get(store, '/public/frontline/'+countryName+'/available')
}

export async function getZipFileUrl( store: Store) {
  // const uniqueId = store.getState().app.configId+'_'+store.getState().app.designId
  const uniqueId = store.getState().app.rowKey
  return config.api_endpoint+'/cad/'+uniqueId+'/get-files-zipped'
  // return await get(store, '/cad/'+uniqueId+'/get-files-zipped')
}

export async function setPageVisited( store: Store, dataToSend:any) {
  // const uniqueId = store.getState().app.configId+'_'+store.getState().app.designId
  const uniqueId = store.getState().app.rowKey
  const requestData = {
    ...dataToSend,
    downloadUrl: window.location.href,
  }
  await get(store, '/public/check')
  return await post(store, '/cad/'+uniqueId+'/page-reached', requestData, { withKeyToken: true, includeAuth: false })
}

export async function setEmail( store: Store, dataToSend:any) {
  // const uniqueId = store.getState().app.configId+'_'+store.getState().app.designId
  const uniqueId = store.getState().app.rowKey
  await get(store, '/public/check')
  return await post(store, '/cad/'+uniqueId+'/add-email', dataToSend, { withKeyToken: true, includeAuth: false })
}

export async function sendEmail( store: Store, dataToSend:any) {
  const emailInformation = {
    ...dataToSend,
    product: store.getState().app.product,
    configurationId: store.getState().app.configId,
    productType: store.getState().app.productType,
    designId: store.getState().app.designId,
    languageCode: store.getState().app.language,
  }
  await get(store, '/public/check')
  return await post(store, '/mail/cad', emailInformation, { withKeyToken: true, includeAuth: false })
}

export async function sendForm( store: Store, dataToSend:any) {
  // const uniqueId = store.getState().app.configId+'_'+store.getState().app.designId
  const uniqueId = store.getState().app.rowKey
  const emailInformation = {
    ...dataToSend,
    product: store.getState().app.product,
    configurationId: store.getState().app.configId,
    productType: store.getState().app.productType,
    designId: store.getState().app.designId,
    languageCode: store.getState().app.language,
  }
  await get(store, '/public/check')
  return await post(store, '/cad/'+uniqueId+'/contact-form', emailInformation, { withKeyToken: true, includeAuth: false })
}

export async function sendFormGeneric( store: Store, dataToSend:any) {
  const formInformation = {
    ...dataToSend,
    product: store.getState().app.product,
    configurationId: store.getState().app.configId,
    productType: store.getState().app.productType,
    designId: store.getState().app.designId,
    languageCode: store.getState().app.language,
  }
  await get(store, '/public/check')
  return await post(store, '/contact/planner-tools', formInformation, { withKeyToken: true, includeAuth: false })
}

export async function sendFeedbackForm( store: Store, dataToSend:any) {
  const formInformation = {
    ...dataToSend,
  }
  await get(store, '/public/check')
  return await post(store, '/contact/planner-feedback', formInformation, { withKeyToken: true, includeAuth: false })
}

export async function makeOrder(store: Store, formData:any) {
  // const uniqueId = store.getState().app.configId+'_'+store.getState().app.designId
  const uniqueId = store.getState().app.rowKey
  const drawingApiParams = apiCalls.find(item => item.type === 'drawing') || {type:'',url:''}
  // const urlParams = {
  //   configId: store.getState().app.configId,
  //   designId: store.getState().app.designId,
  //   productCode: store.getState().app.productCode,
  //   product: store.getState().app.product,
  //   release: store.getState().app.release,
  //   language: store.getState().app.language,
  //   productType: store.getState().app.productType,
  //   cdProductType: store.getState().app.cdProductType,

  // }
  await get(store, '/public/check')
  const result =  await post(store, '/cad/'+uniqueId+'/make-order', formData, { withKeyToken: true, includeAuth: false })
  poll(drawingApiParams,store,{key:uniqueId})
  if(formData.cad || formData.bim) {
    store.dispatch({type:'app/setOrderHasBeenMade',payload:true})
  }
  return result
}

export async function loadDomainRelatedData( store: Store) {
  // const res = await fetch(url)
  // const data = await res.json()
  // await get(store, '/public/check')
  // const data = await get(store, `/public/frontline/domain_data?hostname=${window.location.hostname}`);
  // return data
  await get(store, '/public/check')
  return get(store, `/public/frontline/domain_data?hostname=${window.location.hostname}`);
}

export async function loadFrontlineCountries( store: Store) {
  // const url = "https://qa-kcd3d.azurewebsites.net/api/public/translation/" + language.split(":").join("_")
  const path = "/public/frontline/countries"
  // const data = await get(store, path)
  // return data
  return get(store, path)
}

export async function loadLanguages( store: Store) {
  // const url = "https://qa-kcd3d.azurewebsites.net/api/public/translation/" + language.split(":").join("_")
  const path = "/translation/global/languages"
  // const res = await fetch(url)
  // const data = await res.json()
  // await get(store, '/public/check')
  // const data = await get(store, path)
  // return data
  return get(store, path)
}

export async function loadTranslations( store: Store, language: string) {
  // const url = "https://qa-kcd3d.azurewebsites.net/api/public/translation/" + language.split(":").join("_")

  const path = "/translation/cad/" + language
  // await get(store, '/public/check')
  // const data = await get(store, path)
  // return data
  return get(store, path)
}

export async function initializeMsalApp()  {
  msalApp = await setMsalApp()
  return
}

export async function initializeConfig(store:Store)  {
  config = await setConfig()
  if(config.hide_translation_keys_switch) {
    store.dispatch({type: "app/setCanShowTranslationsKeys", payload:false})
  } else {
    store.dispatch({type: "app/setCanShowTranslationsKeys", payload:true})
  }
  if(config.cdUri) {
    store.dispatch({type: "app/setCDUri", payload:config.cdUri})
  } else {
    store.dispatch({type: "app/setCDUri", payload:'https://cardesigner.kone.com'})
  }
  return
}
